module.exports = __webpack_public_path__ + "img/sub_program.8e9a3d01.svg";